import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterRound = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsxs("filter", {
		id: "round",
		children: [
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				in: "SourceGraphic",
				stdDeviation: 5,
				result: "blur"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "blur",
				mode: "matrix",
				values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 19 -9",
				result: "goo"
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in: "SourceGraphic",
				in2: "goo",
				operator: "atop"
			})
		]
	})
});
export default SvgFilterRound;
